(() => {
  const PRESETS = {
    F7F5F2: "#F7F5F2",
    E5E0D8: "#E5E0D8",
    C9D3C8: "#C9D3C8",
    D8CFC4: "#D8CFC4",
    C9D2DC: "#C9D2DC",
  };

  function syncHexField(root = document) {
    // Theme editor renders settings UI outside the section DOM,
    // so we query globally.
    const presetSelect = root.querySelector(
      '[name*="bg_color_preset"]'
    );
    const hexInput = root.querySelector(
      '[name*="bg_color_hex"]'
    );

    if (!presetSelect || !hexInput) return;

    const apply = () => {
      const key = (presetSelect.value || "").replace("#", "").toUpperCase();
      const hex = PRESETS[key];
      if (hex) hexInput.value = hex;
    };

    // Initial + on change
    apply();
    presetSelect.addEventListener("change", apply);
  }

  // Run on normal load
  document.addEventListener("DOMContentLoaded", () => syncHexField(document));

  // Run when Shopify theme editor re-renders
  document.addEventListener("shopify:section:load", () => syncHexField(document));
  document.addEventListener("shopify:section:select", () => syncHexField(document));
})();
